import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonSpecificationsComponent } from './person-specifications.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { AddressValidatorModule } from '../../address-validator/address-validator.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { ValidationMarkModule } from './validation-mark/validation-mark.module';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { AddressBookService } from 'src/app/pages/admin/address-book/address-book.service';
import { AddressBookContactController } from 'src/app/core/controllers/address-book-contact.controller';
import { AddressBookContactModule } from 'src/app/pages/admin/address-book/address-book-contact/address-book-contact.module';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { InfoDialogComponent } from './dialog-info';

@NgModule({
  declarations: [PersonSpecificationsComponent,InfoDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    AddressValidatorModule,
    MatAutocompleteModule,
    FlexLayoutModule,
    MatCardModule,
    MatLegacyTooltipModule,
    ValidationMarkModule,
    MatIconModule,
    MatButtonModule,
    AddressBookContactModule,
    MatDialogModule,
    MatSelectModule,
  ],
  exports: [PersonSpecificationsComponent],
  providers: [AddressBookService]
})
export class PersonSpecificationsModule {}
